export enum ContactInquireType {
    NONE = "none",
    AX_ADOPTION = "AX_ADOPTION",
    DEMO = "DEMO",
    ENTERPRISE_ADOPTION = "ENTERPRISE_ADOPTION",
    BILLING_ACCOUNT_MANAGEMENT = "BILLING_ACCOUNT_MANAGEMENT",
    PARTNERSHIP_OPPORTUNITIES = "PARTNERSHIP_OPPORTUNITIES",
    MEDIA_PUBLIC_RELATIONS = "MEDIA_PUBLIC_RELATIONS",
    OTHERS = "OTHERS"
}

export enum ContactInquireString {
    AX_ADOPTION = "ax adoption",
    ENTERPRISE_ADOPTION = "sales",
    DEMO = "request a demo",
    BILLING_ACCOUNT_MANAGEMENT = "billing",
    PARTNERSHIP_OPPORTUNITIES = "partnership",
    MEDIA_PUBLIC_RELATIONS = "media",
    OTHERS = "others"
}
